import Model from './Model'

export default class MealGuideCategory extends Model {
  resource() {
    return 'settings/meal-guide-categories'
  }
}
